var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h2',{staticClass:"title is-0 has-text-centered",class:{'has-text-white': this.$root.$children[0].darkTheme}},[_vm._v(" Portfolio ")]),_vm._l((_vm.projects),function(project,index){return _c('Project',{key:project.name,attrs:{"project":project,"index":index}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }